
import Schema from 'AppReact/schema';
import { inspectionTemplate } from 'types';

export default {
  data: Schema({}, 'object', { defaultValue: {} }),
  card: Schema({}, 'object', { defaultValue: {} }),
  makeReadyCategory: Schema({}, 'object', { defaultValue: {} }),
  inspectionTemplates: Schema(inspectionTemplate, 'array', { defaultValue: [] })
}

